import { round } from '@kunalabs-io/kai'

type FormatOptions = {
  approx?: boolean // adds '~' prefix
  showLessThanMinimum?: boolean // shows e.g. "<$0.01" if very small value
  lessThanThreshold?: number // default 0.01
  decimals?: number
  compact?: boolean // shows "M" and "K" in number display
}

const DECIMALS = 2
const LESS_THAN_THRESHOLD = 0.01
const SMALL_USD_VALUE = `<$${LESS_THAN_THRESHOLD}`

export const getFormattedUsdValue = (
  value: number,
  {
    approx = false,
    showLessThanMinimum = true,
    lessThanThreshold = LESS_THAN_THRESHOLD,
    decimals = DECIMALS,
    compact = true,
  }: FormatOptions = {}
): string => {
  if (value === 0) {
    return '$0'
  }

  if (showLessThanMinimum && Math.abs(value) < lessThanThreshold) {
    return SMALL_USD_VALUE
  }

  const sign = value < 0 ? '-' : ''
  const absValue = Math.abs(value)

  let formatted: string

  if (compact && absValue >= 1_000_000) {
    const millions = round(absValue / 1_000_000, 2)
    formatted = `${millions.toLocaleString('en-US', { maximumFractionDigits: 2 })}M`
  } else if (compact && absValue >= 10_000) {
    const thousands = round(absValue / 1_000, 2)
    formatted = `${thousands.toLocaleString('en-US', { maximumFractionDigits: 2 })}K`
  } else {
    const rounded = round(absValue, decimals)
    formatted = rounded.toLocaleString('en-US', {
      maximumFractionDigits: decimals,
    })
  }

  return `${approx ? '~' : ''}${sign}$${formatted}`
}
